import gql from "graphql-tag";

const JOURNEY_EXCEL_QUERY = gql`
  query JourneySummaryExcel(
    $movilesID: [Int]!
    $fechaInicio: Datetime
    $fechaFin: Datetime
    $groupedBy: JourneyGroupEnum
    $days: [WeekDaysEnum]
  ) {
    journeySummaryExcel(
      movilesID: $movilesID
      fechaInicio: $fechaInicio
      fechaFin: $fechaFin
      groupedBy: $groupedBy
      days: $days
    )
  }
`;

export default JOURNEY_EXCEL_QUERY;
